// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__22XW4","item":"PaymentsMobile_item__1lPbD","label":"PaymentsMobile_label__35PVL","amount":"PaymentsMobile_amount__3kqxa"};